import { type ReactNode, useEffect } from 'react';

import { useSettingsStore } from '../stores/settingsStore.js';

export const ThemeRoot = ({ children }: { children: ReactNode }) => {
  const theme = useSettingsStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('light', theme === 'light');
  }, [theme]);

  return <>{children}</>;
};
